import * as React from 'react';
import quickLinksData from './__data__/data.quickLinksData.json';
import QuickLinks from '../../presentational/Dashboard/QuickLinks/QuickLinks';

const QuickLinksContainer = () => <QuickLinks links={quickLinksData} />;

export default QuickLinksContainer;
